import { atom } from 'recoil';

interface IUserState {
  isLoading?: boolean;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  acceptsMarketing?: boolean;
  ordersCount?: number;
  totalSpent?: number;
  addresses?: any[];
  giftCards?: any[];
  orders?: any[];
  defaultAddress?: { id: string };
  availableShoppingCountries: any[];
}
export const UserState = atom<IUserState>({
  key: 'userState',
  default: {
    isLoading: true,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    acceptsMarketing: false,
    ordersCount: null,
    totalSpent: null,
    addresses: null,
    giftCards: [],
    orders: [],
    defaultAddress: null,
    availableShoppingCountries: [],
  },
});
